export enum MenuIndex {
  Default = 0,
  TopNav = 1,
  Overview = 2,
  Accounts = 3,
  UserOptions = 4,
  HildaDetails = 5,
}
